var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.1667C0 15.5091 3.77573 11.7333 8.43333 11.7333C13.0909 11.7333 16.8667 15.5091 16.8667 20.1667V22H0V20.1667Z",
    fill: "#FF0000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.79996,
    cy: 5.13333,
    r: 5.13333,
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.8b91c9aa4d538489ff8ed624ea97fcda.svg";
export { ForwardRef as ReactComponent };